import React from 'react';
import PropTypes from 'prop-types';
import WssOrderInfoCard from './WssOrderInfoCard';
import { textPairProp } from './props';

function WssOrderDetailsSection({
  heading, status, children, hasWssPaymentDetails,
}) {
  const wrapperClassName = hasWssPaymentDetails
    ? 'order-history-wrapper order-history-wrapper--with-payment'
    : 'order-history-wrapper';

  return (
    <div className={wrapperClassName}>
      {/* Order info card with order number and status - only show if WSS flow is active */}
      {hasWssPaymentDetails && (heading || status) && (
        <div className="wss-order-info-section">
          <WssOrderInfoCard heading={heading} status={status} />
        </div>
      )}

      {/* Additional order details content */}
      {children}
    </div>
  );
}

WssOrderDetailsSection.propTypes = {
  heading: textPairProp,
  status: PropTypes.shape({
    label: textPairProp,
    value: PropTypes.string,
  }),
  children: PropTypes.node,
  hasWssPaymentDetails: PropTypes.bool,
};

WssOrderDetailsSection.defaultProps = {
  heading: null,
  status: null,
  children: null,
  hasWssPaymentDetails: false,
};

export default WssOrderDetailsSection;
